import ModalInTailwind from '$components/ModalInTailwind/ModalInTailwind';
import ModalCandidateActions from '$components/Positions/CandidateSummaryCardList/CandidateSummaryCard/CandidateSummaryCardEmployers/ModalCandidateActions/ModalCandidateActions';
import { useAppDispatch } from '$hooks/use-app-dispatch.hook';
import { useAppSelector } from '$hooks/use-app-selector.hook';
import { singlePositionSlice } from '$store/modules/position/position.reducer';
import computeLastJob from '$utils/computeLastJob';
import { useEffect, useState } from 'react';

const SPKInterviewConfirmationModal = () => {
  const dispatch = useAppDispatch();
  const { selectedCandidate, openConfirmationInterviewModal } = useAppSelector(
    (state) => state.position
  );
  const [lastJob, setLastJob] = useState<{
    title: string;
    company: string | null;
  }>({ title: '', company: null });

  useEffect(() => {
    if (selectedCandidate?.CandidateWorkExperience?.length) {
      const lj = computeLastJob(selectedCandidate.CandidateWorkExperience);
      setLastJob(lj);
    } else {
      setLastJob({
        title: 'N/A',
        company: null,
      });
    }
  }, [selectedCandidate?.CandidateWorkExperience]);

  return (
    <ModalInTailwind
      isOpen={openConfirmationInterviewModal}
      closeModal={() =>
        dispatch(
          singlePositionSlice.actions.setOpenConfirmationInterviewModal(false)
        )
      }
    >
      <ModalCandidateActions
        closeModal={() =>
          dispatch(
            singlePositionSlice.actions.setOpenConfirmationInterviewModal(false)
          )
        }
        img={selectedCandidate?.User?.ProfilePicture?.Url}
        candidateFirstName={selectedCandidate?.User?.FirstName}
        candidateLastName={selectedCandidate?.User?.LastName}
        lastJob={lastJob}
        score={
          selectedCandidate && 'Score' in selectedCandidate
            ? selectedCandidate.Score
            : 0
        }
        handleOk={() => {
          dispatch(
            singlePositionSlice.actions.setOpenConfirmationInterviewModal(false)
          );
          dispatch(
            singlePositionSlice.actions.setOpenInterviewCalendarModal(true)
          );
        }}
        type="interview"
        className="max-w-[450px]"
        hideCloseButton
      />
    </ModalInTailwind>
  );
};

export default SPKInterviewConfirmationModal;
